import { render } from "./message-notifications.vue?vue&type=template&id=ef36d3ca&scoped=true"
import script from "./message-notifications.vue?vue&type=script&lang=js"
export * from "./message-notifications.vue?vue&type=script&lang=js"

import "./message-notifications.vue?vue&type=style&index=0&id=ef36d3ca&lang=scss&scoped=true"

import exportComponent from "c:\\jenkins\\workspace\\Client_Windows_build\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef36d3ca"]])

export default __exports__
import QMenu from 'quasar/src/components/menu/QMenu.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QMenu});
